import { render, staticRenderFns } from "./OrderDetailsView.vue?vue&type=template&id=73f93160&"
import script from "./OrderDetailsView.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrderDetailsView.vue"
export default component.exports